
export default {
    name: "PlatformHome",
    data() {
        return {
            resultData: {},
            firstDay: this.getFirstDay(),
            lastDay: this.getLastDay()
            // companyNumber: 0,
            // userNumber: 0,
            // accumulatedCharges: 0,
            // addCompanyNumber: 0,
            // addUserNumber: 0,
            // addAccumulatedCharges: 0,
            // blNumber: 0,
            // printBLNumber: 0,
            // notPrintBLNumber: 0,
            // addPrintBLNumber: 0,
            // addBLNumber: 0,
            // abandonedBLNumber: 0,
            // waitApplyBusCustomer: 0,
            // waitApplyAbandoned: 0,
            // waitApplyPrint: 0,
            // waitSendBLFile: 0,
            // waitPrintBLFile: 0,
            // notUploadSealCompany: 0
        }
    },
    mounted: function () {
    },
    created() {
        this.$axios.get('/api/admin/indexCustomer').then(response => {
            this.resultData = response.data.resultData;
        }).catch(e => {
            console.log(e);
            this.$message({
                message: this.$t('common.message.operateFail'),
                type: 'error',
                center: true
            });
        });
    },
    methods: {
        toView(url, param){
            if(!param) {
                param = {
                    searchForm: {pageIndex: 1, pageNum: 1,pageSize: 50},
                    row: {}
                };
            }else{
                param = {pageIndex: 1, pageNum: 1, pageSize: 50, ...param};
            }
            // 设置参数
            this.$routerUtil.setParam(param);
            this.$router.push(url);
        },
        getFirstDay(){
            const date = new Date();
            date.setDate(1);
            return this.dateToYYYYMMDD(date);
        },
        getLastDay(){
            const date = new Date();
            date.setDate(1);
            date.setMonth(date.getMonth() + 1);
            date.setDate(date.getDate() - 1);
            return this.dateToYYYYMMDD(date);
        },
        dateToYYYYMMDD(date){
            let d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        }
    }
}
